export class SchedulerFilterSettingsModel {
  public SchedulerDate: string;
  public ExecutedAt: string;
  public IsActive?: boolean;
}